import React from "react"
import { CustomModal } from "./modal"
import { useMutation } from "react-query"
import { updateTransactionTracking } from "../services/expert"
import { Button } from "./button"
import * as Yup from "yup"
import { Formik, Form } from "formik"
import { ensureHttpsUrl, isValidUrl } from "../utils"

function AddTrackingLinkModal({ transaction, onClose, onSuccess }) {
    const isOpen = Boolean(transaction)

    const { mutate, isLoading } = useMutation((data) => updateTransactionTracking(transaction.id, data), {
        onSuccess: () => {
            alert("Tracking link added successfully!")
            onSuccess()
            onClose()
        },
        onError: e => {
            alert(e.data?.message || 'Failed to add tracking link')
        }
    })

    return (
        <CustomModal
            open={isOpen}
            onClose={onClose}
            className="commonCustomModal feedbackModal"
            body={transaction ? (
                <Formik
                    initialValues={{
                        payment_tracking_link: transaction?.payment_tracking_link || '',
                    }}
                    validationSchema={Yup.object().shape({
                        payment_tracking_link: Yup.string()
                            .required('Tracking link is required')
                            .test('is-valid-url', 'Please enter a valid URL', (value) => {
                                if (!value) return false
                                return isValidUrl(value.trim()) || isValidUrl(`https://${value.trim()}`)
                            }),
                    })}
                    validateOnChange={false}
                    validateOnBlur={false}
                    onSubmit={(values, { setSubmitting }) => {
                        mutate({
                            payment_tracking_link: ensureHttpsUrl(values.payment_tracking_link.trim()),
                        })
                        setSubmitting(false);
                    }}
                >
                    {({ handleChange, errors, values, touched }) => (
                        <Form className="form mt-30">
                            <div className="mb-20">
                                <label htmlFor="payment_tracking_link">Tracking Link *</label>
                                <input
                                    required
                                    type="text"
                                    name="payment_tracking_link"
                                    value={values.payment_tracking_link}
                                    onChange={handleChange}
                                    className="stllr-input"
                                    placeholder="Enter tracking link (https:// will be added automatically)"
                                />
                                {errors.payment_tracking_link && touched.payment_tracking_link ? (
                                    <span className="v-error">{errors.payment_tracking_link}</span>
                                ) : null}
                            </div>

                            <div className="is-flex aic jcfe">
                                <Button
                                    text='Cancel'
                                    onClick={onClose}
                                    className='secondary bordered btn-md mr-10'
                                    disabled={isLoading}
                                />
                                <Button
                                    text='Add Tracking Link'
                                    type='submit'
                                    className='primary btn-md'
                                    disabled={isLoading}
                                />
                            </div>
                        </Form>
                    )}
                </Formik>
            ) : "Loading..."}
        />
    )
}

export { AddTrackingLinkModal }
